





























import { EnterpriceBankData as IntefaceEnterpriceBankData } from '@/store/interfaces/company';
import companyTypes from '@/store/types/company';
import resourceTypes from '@/store/types/resources';
import { PAYMENT_TYPES } from '@/const/paymentTypes';
import Vue, { PropType } from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import divider from '@/components/Reusable/divider.vue';
import UsdBankForm from './UsdBankForm.vue';
import UsdtBankForm from './UsdtBankForm.vue';

export default Vue.extend({
  name: 'EnterpriseBankData',
  components: {
    divider,
    UsdBankForm,
    UsdtBankForm,
  },
  props: {
    update: {
      required: false,
      default: false,
      type: Boolean,
    },
    bankDataModel: {
      required: false,
      default: () => ({}),
      type: Object as PropType<IntefaceEnterpriceBankData>,
    },
  },
  data: () => ({
    PAYMENT_TYPES,
    company_bank_account: {
      payment_type: '',
    } as IntefaceEnterpriceBankData,
  }),
  computed: {
    ...mapGetters({
      getNewCompanyParams: `companyModule/${companyTypes.getters.GET_NEW_COMPANY_PARAMS}`,
      currencies: `resourcesModule/${resourceTypes.getters.GET_CURRENCIES}`,
    }),
  },
  methods: {
    ...mapActions({
      fetchCurrencies: `resourcesModule/${resourceTypes.actions.CURRENCIES}`,
    }),
    ...mapMutations({
      setBankData: `companyModule/${companyTypes.mutations.SET_COMPANY_BANK_ACCOUNT}`,
    }),
    assignBankData(): void {
      this.company_bank_account = this.update
        ? this.bankDataModel
        : this.getNewCompanyParams.company_bank_account;
    },
    initializeUSDFields(): void {
      this.company_bank_account = {
        bank_name: this.company_bank_account.bank_name || '',
        bank_address: this.company_bank_account.bank_address || '',
        account_number: this.company_bank_account.account_number || '',
        account_holder: this.company_bank_account.account_holder || '',
        aba_routing_number: this.company_bank_account.aba_routing_number || '',
        swift_code: this.company_bank_account.swift_code || '',
        corresponsal_information:
          this.company_bank_account.corresponsal_information || '',
        notes: this.company_bank_account.notes || '',
        payment_type: this.company_bank_account.payment_type,
      };
    },
    initializeUSDTFields(): void {
      this.company_bank_account = {
        payment_type: this.company_bank_account.payment_type,
        blockchain: this.company_bank_account.blockchain || '',
        wallet_address: this.company_bank_account.wallet_address || '',
        confirm_wallet_address:
          this.company_bank_account.confirm_wallet_address || '',
        legal_disclaimer: this.company_bank_account.legal_disclaimer || false,
      };
    },
  },
  watch: {
    'company_bank_account.payment_type': {
      handler(newPaymentType: string): void {
        if (newPaymentType === PAYMENT_TYPES.USD) {
          this.initializeUSDFields();
        } else if (newPaymentType === PAYMENT_TYPES.USDT) {
          this.initializeUSDTFields();
        }
      },
    },
    company_bank_account: {
      immediate: true,
      deep: true,
      handler(val: IntefaceEnterpriceBankData): void {
        setTimeout(() => {
          if (this.update) {
            this.$emit('update:bank-data-model', val);
          } else {
            this.setBankData(val);
          }
        }, 500);
      },
    },
  },
  async mounted(): Promise<void> {
    this.assignBankData();
    await this.fetchCurrencies();
  },
});
